module.exports = __webpack_public_path__ + "img/undraw_doctor_kw5l.fc479b85.svg";